import { createStandardAction } from 'typesafe-actions';

import type { Chat } from 'Chat-Types';

export const setChat = createStandardAction('SET_CHAT')<Chat>();
export const clearChat = createStandardAction('CLEAR_CHAT')();
